export default "__VITE_ASSET__C2axe2wJ__"